import { Injectable } from '@angular/core';
import { ContextFactory } from '@shared/factories/context/context.factory';
import { ApiServiceService } from '@shared/services/api-service/api-service.service';

@Injectable({
  providedIn: 'root'
})
export class GlobalCustomizationResolver  {
  constructor(private apiService: ApiServiceService,
    private context: ContextFactory) { }
  resolve() {
    return this.apiService.get('company/globalcustomization', this.context.user.companyId)
      .then((data:any)=> {
        return data;
      })
  }
}
